module.exports = __webpack_public_path__ + "img/960.88c7e462.svg";